import React, { useState } from "react";

// import JS files
import MuiModal from "../shares/MuiModal";

// import Others files
import waitingIcon from "../../imgs/waiting.svg";

const AppDownloadModal = (props) => {
  return (
    <>
      <MuiModal
        openModal={props.openModal}
        setOpenModal={props.setOpenModal}
        width="w-2/5"
      >
        <div className="flex flex-col items-center justify-center p-4">
          <img src={waitingIcon} />
          <p className="font-bold text-mygray-700 mt-8">به زودی!</p>
          <p className="text-sm leading-8 text-mygray-500 mt-8">
            باتوجه به اینکه قرارداد جدید اخیرا شروع شده است اپلیکیشن بدلیل ثبت
            کد ملی تمام بیمه شده ها و جمع آوری دیتا تا چند روز دیگر قابل استفاده
            می باشد.
          </p>
        </div>
      </MuiModal>
    </>
  );
};

export default AppDownloadModal;
